export const TrainingSession = {
    path: '/training_sessions',
    name: 'training_sessions',
    component: () => import('@/views/Training/TrainingSession/TrainingSessionPage.vue'),
    children: [
        {
            path: '/training_sessions/add',
            name: 'training_sessions.add',
            component: () => import('@/views/Training/TrainingSession/Form/TrainingSessionForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/training_sessions/edit/:id',
            name: 'training_sessions.edit',
            component: () => import('@/views/Training/TrainingSession/Form/TrainingSessionForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/training_sessions/delete/:id',
            name: 'training_sessions.delete',
            component: () => import('@/views/Training/TrainingSession/Form/TrainingSessionForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/training_sessions/view/:id',
            name: 'training_sessions.view',
            component: () => import('@/views/Training/TrainingSession/Form/TrainingSessionForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/training_sessions/launch/:id',
            name: 'training_sessions.launch',
            component: () => import('@/views/Training/TrainingSession/Form/TrainingSessionForm.vue'),
            props: {launchAction: true}
        },
        {
            path: '/training_sessions/pointing/:id',
            name: 'training_sessions.pointing',
            component: () => import('@/views/Training/TrainingSession/Form/TrainingSessionForm.vue'),
            props: {pointingAction: true}
        },
        {
            path: '/training_sessions/lock/:id',
            name: 'training_sessions.lock',
            component: () => import('@/views/Training/TrainingSession/Form/TrainingSessionForm.vue'),
            props: {lockAction: true}
        },
        {
            path: '/training_sessions/lock/:id',
            name: 'training_sessions.lock',
            component: () => import('@/views/Training/TrainingSession/Form/TrainingSessionForm.vue'),
            props: {lockAction: true}
        },
        {
            path: '/training_sessions/documents/:id',
            name: 'training_sessions.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "TRAINING_SESSION"}
        },
    ],
}

export const TrainingHotEvaluation = {
    path: '/training_hot_evaluations',
    name: 'training_hot_evaluations',
    component: () => import('@/views/Training/TrainingSession/HotEvaluationPage.vue'),
    children: [
        {
            path: '/training_hot_evaluations/view/:id',
            name: 'training_hot_evaluations.view',
            component: () => import('@/views/Training/TrainingSession/Form/TrainingSessionForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/training_hot_evaluations/interview/view/:id',
            name: 'training_hot_evaluations.interview.view',
            component: () => import('@/views/Evaluation/EvaluationInterview/Form/EvaluationTrainingHotInterviewForm.vue'),
            props: {viewAction: true}
        }
    ]
}

export const TrainingColdEvaluation = {
    path: '/training_cold_evaluations',
    name: 'training_cold_evaluations',
    component: () => import('@/views/Training/TrainingSession/ColdEvaluationPage.vue'),
    children: [
        {
            path: '/training_cold_evaluations/view/:id',
            name: 'training_cold_evaluations.view',
            component: () => import('@/views/Training/TrainingSession/Form/TrainingSessionForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/training_cold_evaluations/interview/view/:id',
            name: 'training_cold_evaluations.interview.view',
            component: () => import('@/views/Evaluation/EvaluationInterview/Form/EvaluationTrainingColdInterviewForm.vue'),
            props: {viewAction: true}
        }
    ]
}